// extracted by mini-css-extract-plugin
export default {"button":"LpXzaZy","active":"fyxh6xK","icon":"ARNiOkY","disabled":"cYGqURx","error":"Mu4nYyO","text":"kPRvbob"};